<template>
	<div class="page" style="text-align: center">
		<div v-if="!bots" style="position: fixed;inset: 0;z-index: 1000;xpointer-events: none;">
			<div class="ant-drawer-mask" style="position: absolute;inset: 0;z-index: 1000;background: rgba(0, 0, 0, 0.55);pointer-events: auto;"></div>
			<div style="position: absolute;z-index: 1001;top: 30%;width: 100vw;">
				<div style="color: orangered;padding-bottom: 50px;font-size: 15px;font-weight: bold;">
					<div>陪练前，请确保手机不要静音</div>
					<div>否则有可能无法进行语音对话</div>
				</div>
				<div class="uni-flex">
					<div style="-webkit-flex: 1;flex: 1;"></div>
					<a-spin :spinning="spinning">
					<div @click="getBot(0)" class="uni-flex" style="width: 164px;height: 68px;background: linear-gradient( 270deg, #CEF2FF 0%, #AEBCFF 100%);border-radius: 12px;padding: 12px;">
						<div style="padding-right: 10px;">
							<img src="https://h5.wuweimed.com/static/chat/011.png" style="width: 44px;">
						</div>
						<div style="padding-top: 2px;text-align: left;">
							<div style="color: #333333;font-weight: bold;">产品介绍陪练</div>
							<div style="color: #6472AE;font-size: 12px;padding-top: 6px;">开始陪练 > </div>
						</div>
					</div>
					</a-spin>
					<div style="width: 20px;"></div>
					<a-spin :spinning="spinning">
					<div @click="getBot(1)" class="uni-flex" style="width: 164px;height: 68px;background: linear-gradient( 270deg, #CEF2FF 0%, #AEBCFF 100%);border-radius: 12px;padding: 12px;">
						<div style="padding-right: 10px;">
							<img src="https://h5.wuweimed.com/static/chat/012.png" style="width: 44px;">
						</div>
						<div style="padding-top: 2px;text-align: left;">
							<div style="color: #333333;font-weight: bold;">销售技巧陪练</div>
							<div style="color: #6472AE;font-size: 12px;padding-top: 6px;">开始陪练 > </div>
						</div>
					</div>
					</a-spin>
					<div style="-webkit-flex: 1;flex: 1;"></div>
				</div>
			</div>
		</div>
		<div class="uni-flex" style="padding: 8px 9px 0 9px;">
			<div class="uni-flex" style="width: 24px;">
				<img src="https://h5.wuweimed.com/static/chat/001.png" style="width: 24px;">
			</div>
			<div @click="handleDisconnect" class="uni-flex" style="-webkit-flex: 1;flex: 1;-webkit-justify-content: center;justify-content: center;-webkit-align-items: center;align-items: center;">
				<text style="font-size: 18px;font-weight: bold;color: #FFFFFF;">演练畅聊</text>
			</div>
			<div style="width: 24px;"></div>
		</div>
		<div style="position: fixed;width: 100vw;top: 40px;">
			<div class="uni-flex" style="padding: 0 17px;">
				<div style="-webkit-flex: 1;flex: 1;"></div>
				<div>
					<img v-if="botInfo.avatar" :src="botInfo.avatar" style="width: 120px;">
					<img v-else src="https://h5.wuweimed.com/static/chat/007.png" style="width: 94px;">
				</div>
				<div style="-webkit-flex: 1;flex: 1;padding-top: 7px;">
					<div class="uni-flex" style="width: 125px;height: 28px;background: rgba(255,255,255,0.2);box-shadow: inset 0px 0px 4px 0px rgba(255,255,255,0.5);border-radius: 20px 20px 20px 0px;padding: 0 10px;line-height: 26px;">
						<div class="uni-flex" style="-webkit-align-items: center;align-items: center;padding-right: 5px;">
							<img src="https://h5.wuweimed.com/static/chat/008.png" style="width: 14px;height: 14px;">
						</div>
						<div style="font-size: 12px;color: #697EDA;">角色：{{botInfo.role||'中年男性'}}</div>
					</div>
				</div>
			</div>
			<div v-if="false&&chatList.length==0" style="padding: 0 100px;">
				<div class="scroll-container">
					<div class="scroll-text" style="font-size: 12px;color: #FFFFFF;">当前进入营业厅的角色为中年男性，40岁左右，敬请接待</div>
				</div>
			</div>
		</div>
		<div style="position: absolute;width: 100%;top: 150px;">
			<div id="chatList" style="height: calc(100vh - 150px - 85px); overflow-y: auto;">
			<!-- 介绍 -->
			<div v-if="bots" class="uni-flex" style="padding: 6px 16px;padding-bottom: 24px;">
				<div style="width: 44px;">
					<img :src="bots.icon_url" style="width: 36px;border-radius: 100%;">
				</div>
				<div>
					<div style="width: 300px;background: #C2E0FF;box-shadow: 0 4px 6px 0 rgba(0,0,0,0.04);border-radius: 12px;padding: 12px;">
						<div style="text-align: left;">
							<div style="font-size: 14px;font-weight: bold;margin-bottom: 5px;">{{bots.name}}</div>
							<text>{{bots.description}}</text>
						</div>
					</div>
					<div @click="play(bots.description,'7426720361733193737')" style="text-align: left;padding-top: 5px;">
						<img src="https://h5.wuweimed.com/static/chat/015.png" style="width: 20px;">
					</div>
				</div>
			</div>
			<div style="padding: 0 16px;" v-for="(item,index) in chatList" :key="index">
				<!-- ai顾客 -->
				<div v-if="item.role==='assistant'">
				<div class="uni-flex" style="padding-top: 6px;padding-bottom: 24px;">
					<div style="width: 44px;">
						<img :src="botInfo.avatar" style="width: 36px;border-radius: 100%;">
					</div>
					<div>
						<div style="width: 300px;background: #C2E0FF;box-shadow: 0 4px 6px 0 rgba(0,0,0,0.04);border-radius: 12px;padding: 12px;">
							<div style="text-align: left;">
								<text>{{item.content}}</text>
							</div>
							<div v-show="false" style="padding: 8px 0;">
								<div class="uni-flex">
									<a-button type="primary" size="small" :loading="item.loading=='intention'" @click="quickChat(index, 'intention')" :style="{'background-color': item.show=='intention'?'#5675FF':'#B7D5FF'}" style="border-radius: 100px;">
										<text :style="{'color': item.show=='intention'?'#fff':'#5675FF'}" style="font-size: 12px;">意图揣摩</text>
									</a-button>
									<a-button type="primary" size="small" :loading="item.loading=='emotion'" @click="quickChat(index, 'emotion')" :style="{'background-color': item.show=='emotion'?'#5675FF':'#B7D5FF'}" style="border-radius: 100px;margin: 0 6px;">
										<text :style="{'color': item.show=='emotion'?'#fff':'#5675FF'}" style="font-size: 12px;">情绪分析</text>
									</a-button>
									<a-button type="primary" size="small" :loading="item.loading=='respond'" @click="quickChat(index, 'respond')" :style="{'background-color': item.show=='respond'?'#5675FF':'#B7D5FF'}" style="border-radius: 100px;">
										<text :style="{'color': item.show=='respond'?'#fff':'#5675FF'}" style="font-size: 12px;">应对技巧</text>
									</a-button>
								</div>
							</div>
							<div v-if="item.show=='intention'&&item.intention" style="background: #EEF1FF;border-radius: 8px;padding: 6px 12px;margin-top: 5px;">
								<div style="text-align: left;">
									<img src="https://h5.wuweimed.com/static/chat/006.png" style="width: 16px;">
									<text style="font-size: 13px;padding-left: 5px;">意图揣摩：</text>
								</div>
								<div style="text-align: left;">
									<text style="font-size: 12px;color: #6E7BB5;">{{item.intention}}</text>
								</div>
							</div>
							<div v-if="item.show=='emotion'&&item.emotion" style="background: #EEF1FF;border-radius: 8px;padding: 6px 12px;margin-top: 5px;">
								<div style="text-align: left;margin-top: 5px;">
									<img src="https://h5.wuweimed.com/static/chat/006.png" style="width: 16px;">
									<text style="font-size: 13px;padding-left: 5px;">情绪分析：</text>
								</div>
								<div style="text-align: left;margin-top: 5px;">
									<text style="font-size: 12px;color: #6E7BB5;">{{item.emotion}}</text>
								</div>
							</div>
							<div v-if="item.show=='respond'&&item.respond" style="background: #EEF1FF;border-radius: 8px;padding: 6px 12px;margin-top: 5px;">
								<div style="text-align: left;">
									<img src="https://h5.wuweimed.com/static/chat/006.png" style="width: 16px;">
									<text style="font-size: 13px;padding-left: 5px;">应对技巧：</text>
								</div>
								<div style="text-align: left;margin-top: 5px;">
									<text style="font-size: 12px;color: #6E7BB5;">{{item.respond}}</text>
								</div>
							</div>
						</div>
						<div @click="play(item.content,botInfo.voice_id)" style="text-align: left;padding-top: 5px;">
							<img src="https://h5.wuweimed.com/static/chat/015.png" style="width: 20px;">
						</div>
					</div>
				</div>
				</div>
				<div v-else-if="item.role==='user'">
				<!-- 营业员 -->
				<div class="uni-flex" style="padding-top: 6px;padding-bottom: 24px;">
					<div style="width: 44px;"></div>
					<div>
						<div style="width: 320px;background: #FFFFFF;box-shadow: 0 4px 6px 0 rgba(0,0,0,0.04);border-radius: 12px;padding: 12px;">
							<div style="text-align: left;">
								<text>{{item.content}}</text>
							</div>
							<div v-show="false" style="padding: 8px 0;">
								<div class="uni-flex">
									<a-button type="primary" size="small" :loading="item.loading=='score'" @click="quickChat(index, 'score')" :style="{'background-color': item.show=='score'?'#5675FF':'#EEF1FF'}" style="border-radius: 100px;">
										<text :style="{'color': item.show=='score'?'#fff':'#5675FF'}" style="font-size: 12px;">{{item.score?`评分: ${item.score}`:'评分'}}</text>
									</a-button>
									<a-button type="primary" size="small" :loading="item.loading=='suggestion'" @click="quickChat(index, 'suggestion')" :style="{'background-color': item.show=='suggestion'?'#5675FF':'#EEF1FF'}" style="border-radius: 100px;margin: 0 6px;">
										<text :style="{'color': item.show=='suggestion'?'#fff':'#5675FF'}" style="font-size: 12px;">改进建议</text>
									</a-button>
									<a-button type="primary" size="small" :loading="item.loading=='analysis'" @click="quickChat(index, 'analysis')" :style="{'background-color': item.show=='analysis'?'#5675FF':'#EEF1FF'}" style="border-radius: 100px;">
										<text :style="{'color': item.show=='analysis'?'#fff':'#5675FF'}" style="font-size: 12px;">详细分析</text>
									</a-button>
								</div>
							</div>
							<div v-if="item.show=='suggestion'&&item.suggestion" style="background: #EEF1FF;border-radius: 8px;padding: 6px 12px;margin-top: 5px;">
								<div style="text-align: left;">
									<img src="https://h5.wuweimed.com/static/chat/004.png" style="width: 16px;">
									<text style="font-size: 13px;padding-left: 5px;">改进建议：</text>
								</div>
								<div style="text-align: left;margin-top: 5px;">
									<text style="font-size: 12px;color: #6E7BB5;">{{item.suggestion}}</text>
								</div>
							</div>
							<div v-if="item.show=='analysis'&&item.analysis" style="background: #EEF1FF;border-radius: 8px;padding: 6px 12px;margin-top: 5px;">
								<div style="text-align: left;">
									<img src="https://h5.wuweimed.com/static/chat/004.png" style="width: 16px;">
									<text style="font-size: 13px;padding-left: 5px;">详细分析：</text>
								</div>
								<div style="text-align: left;margin-top: 5px;">
									<text style="font-size: 12px;color: #6E7BB5;">{{item.analysis}}</text>
								</div>
							</div>
						</div>
						<div @click="play(item.content,'7426720361732980745')" style="text-align: left;padding-top: 5px;">
							<img src="https://h5.wuweimed.com/static/chat/015.png" style="width: 20px;">
						</div>
					</div>
				</div>
				</div>
				<div v-else-if="item.role==='report'">
				<div style="font-size: 12px;color: #fff;opacity: 0.6;">对话结束，本次演练评语</div>
				<div class="uni-flex" style="padding-top: 6px;padding-bottom: 24px;">
					<div style="width: 44px;">
						<img :src="bots.icon_url" style="width: 36px;border-radius: 100%;">
					</div>
					<div>
						<div style="width: 300px;background: #FFFFFF;box-shadow: 0 4px 6px 0 rgba(0,0,0,0.04);border-radius: 12px;padding: 12px;">
							<div style="text-align: left;min-height: 50px;">
								<div v-if="item.content==''">评语生成中...</div>
								<div v-html="md.render(item.content)"></div>
							</div>
						</div>
						<div @click="play(item.content, '7426720361733193737')" style="text-align: left;padding-top: 5px;">
							<img src="https://h5.wuweimed.com/static/chat/015.png" style="width: 20px;">
						</div>
					</div>
				</div>
				</div>
			</div>
			</div>
		</div>
		
		<div v-show="popup" style="position: fixed;bottom: 85px;background: #DFEBFF;padding: 16px;border-radius: 15px 15px 0 0;border-bottom: 1px solid #D2DDF5;min-height: 150px;width: 100vw;">
			<div style="width: 100px;background: linear-gradient( 90deg, #6783FF 0%, #7967FF 100%);border-radius: 100px;padding: 0 10px;line-height: 28px;">
				<img src="https://h5.wuweimed.com/static/chat/002.png" style="width: 16px;">
				<text style="font-size: 13px;padding-left: 5px;color: #fff;">对话灵感</text>
			</div>
			<div style="background: #FFFFFF;box-shadow: 0 4px 6px 0 rgba(0,0,0,0.04);border-radius: 0 12px 12px 12px;margin-top: 8px;padding: 12px;text-align: left;min-height: 50px;">
				<text style="font-size: 14px;">{{remind}}</text>
			</div>
		</div>
		<div v-show="isConnected&&audioEnabled" style="position: fixed;bottom: 85px;background: #DFEBFF;border-radius: 15px 15px 0 0;border-bottom: 1px solid #D2DDF5;width: 100vw;">
			<img src="./assets/04.gif" style="width: 140px;">
			<div style="position: absolute;bottom: 5px;left: 50%;transform: translateX(-50%);">
				<a-button type="primary" size="small" style="border-radius: 20px;background-color: #5675FF;">
					<text style="font-size: 12px;color: #fff;padding: 0 5px;">{{formatSeconds(time)}}</text>
				</a-button>
			</div>
		</div>
		<div style="position: fixed;bottom: 0;width: 100vw;z-index: 9;">
			<div class="bg-but" style="padding: 15px 16px 20px 16px;background-color: #DFEBFF;">
				<div class="uni-flex" style="height: 50px;">
					<div style="padding-right: 10px;" @click="remindChat">
						<img src="https://h5.wuweimed.com/static/chat/005.png" style="width: 58px;">
					</div>
					<div style="-webkit-flex: 1;flex: 1;">
						<a-button v-if="isConnected || isConnecting" @click="voiceChat" type="primary" ghost style="width: 270px;height: 50px;border: 1px solid #7A90BD;border-radius: 12px;">
							<div style="position: relative;display: inline-block;">
								<img src="https://h5.wuweimed.com/static/chat/003.png" style="width: 14px;">
								<!-- <img v-if="!audioEnabled" src="./assets/stop.png" style="width: 10px;position: absolute;left: 5px;bottom: 1px;"> -->
							</div>
							<text style="color: #7A90BD;padding-left: 6px;font-weight: bold;vertical-align: middle;font-size: 16px;">{{isConnected&&audioEnabled?'确认发送':'点击说话'}}</text>
						</a-button>
						<a-button v-else type="primary" ghost style="width: 270px;height: 50px;border: 1px solid #7A90BD;border-radius: 12px;">
							<div style="position: relative;display: inline-block;">
								<img src="https://h5.wuweimed.com/static/chat/003.png" style="width: 14px;">
								<!-- <img v-if="!audioEnabled" src="./assets/stop.png" style="width: 10px;position: absolute;left: 5px;bottom: 1px;"> -->
							</div>
							<text style="color: #7A90BD;padding-left: 6px;font-weight: bold;vertical-align: middle;font-size: 16px;">点击说话</text>
						</a-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { ref, onUnmounted } from 'vue';
	import axios from 'axios';
	import { message } from 'ant-design-vue';
	import { EventNames, RealtimeAPIError, RealtimeClient, RealtimeError, RealtimeUtils } from '@coze/realtime-api';
	import { CozeAPI, COZE_CN_BASE_URL, ChatEventType, ChatStatus, RoleType, COZE_CN_BASE_WS_URL, WebsocketsEventType } from '@coze/api';
	import { WsSpeechClient } from '@coze/api/ws-tools';
	import { useTokenWithPat, useTokenWithWeb, useTokenWithJWT, useTokenWithDevice, useTokenWithPKCE } from './hooks/index';
	import { NetworkErrorManager } from './network-error-manager';
	import { WavRecorder, WavStreamPlayer } from './lib/wavtools';
	import { customerList } from './customer.js';
	import polyfill from './lib/wavtools/base64.js';
	import markdownit from 'markdown-it';

	const { getToken } = useTokenWithPat();
	const wavRecorder = new WavRecorder({ sampleRate: 24000 });
	const wavStreamPlayer = new WavStreamPlayer({ sampleRate: 24000 });

	export default {
		data() {
			return {
				popup: false,
				api: null,
				audio: null,
				client: null,
				chatList: [],
				isConnecting: false,
				isConnected: false,
				audioEnabled: false,
				isSupportVideo: false,
				isSupportAudio: false,
				connectStatus: 'disconnected',
				networkManager: null,
				botId: '',
				remind: '',
				time: 0,
				intervalID: null,
				wait: false,
				keywords: ['入手一份', '买一份', '保险我买了', '不买了', '保险我不买了'],
				end: false,
				md: markdownit(),
				bots: null,
				isWspConnected: false,
				spinning: true,
				error: '',
				botInfo: {},
				botList: [
					// 产品介绍陪练
					[customerList[0], customerList[1], customerList[2], customerList[0], customerList[1], customerList[2]],
					// 销售技巧陪练
					[customerList[3], customerList[4], customerList[5], customerList[3], customerList[4], customerList[5]]
				],
				conversation_id: 0,
			};
		},
		mounted() {
			this.permission();
		},
		methods: {
			async permission() {
				// 获取克风访问权限
				const permission = await RealtimeUtils.checkDevicePermission(false);
				if (!permission.audio) {
					message.error('需要麦克风访问权限');
				}
				this.isSupportVideo = permission.video;
				this.isSupportAudio = permission.audio;
				setTimeout(()=>{
					this.spinning = false;
				}, 1500)
			},
			getBot(key){
				const index = Math.floor(Math.random() * this.botList[key].length);
				this.botInfo = this.botList[key][index];
				this.botInfo.key = key.toString();
				this.initApi(this.botInfo.bot_id);
			},
			async initApi(botId) {
				if(this.spinning){
					return;
				}
				if(!this.isSupportAudio){
					message.error('需要麦克风访问权限');
					return;
				}
				this.botId = botId;
				// 初始化
				this.api = new CozeAPI({
					token: getToken,
					baseURL: COZE_CN_BASE_URL,
					allowPersonalAccessTokenInBrowser: true,
					baseWsURL: COZE_CN_BASE_WS_URL,
					debug: false,
				});

				// 获取智能体信息
				this.bots = await this.api.bots.retrieve({
					bot_id: botId,
				});

				// 播报开场白并在播报完成后连接智能体
				this.play(this.bots.description, '7426720361733193737', () => {
					//连接RTC
					this.isConnecting = true;
					this.handleConnect();
				});
			},
			// 语音合成并播报
			async play(message, voiceId, onSuccess) {
				this.handleInterrupt();
				if (this.isWspConnected) {
					wavStreamPlayer.interrupt();
				}
				if (this.audio && this.audio.isPlaying()) {
					// 暂停语音播放
					this.audio.pause();
					// 断开连接，销毁实例
					this.audio.disconnect();
				}

				// 初始化
				this.audio = new WsSpeechClient({
					token: getToken,
					baseWsURL: COZE_CN_BASE_WS_URL,
					allowPersonalAccessTokenInBrowser: true,
				});
				
				this.audio.on('data', data => {
					// console.log(this.audio.totalDuration);
				});

				// 监听播放完成事件
				this.audio.on('completed', () => {
					console.log('[speech] playback completed');
					setTimeout(() => {
						onSuccess?.();
					}, 500);
				});

				// 连接
				try {
					await this.audio.connect({
						voiceId: voiceId
					});
					console.log('[speech] ws connect success');
				} catch (error) {
					console.error('[speech] ws connect error', error);
					return;
				}

				// 发送消息并播放
				this.audio.appendAndComplete(message);
			},
			// 对话报告
			async reportChat(key) {
				let index = this.chatList.length;
				if (index > 0) {
					let content = '';
					this.chatList.map((item, key) => {
						if (item.role != 'report') {
							content += item.role == 'assistant' ? '顾客：' : '业务员：';
							content += item.content;
							content += "\n";
						}
					});
					
					if(this.botInfo.key == 0){
						content += `\n本次是产品介绍陪练，`
					}
					if(this.botInfo.key == 1){
						content += `\n本次是销售技巧陪练，`
					}
					if (key <= 2) {
						content += `顾客表现出购买意愿时，判定本单卖出，请点评上述对话。`
					} else {
						content += `顾客表现出不愿意购买意愿，判定本单未卖出，请点评上述对话。`
					}

					// WebSocket OpenAPI 双向流式对话事件
					const ws = await this.api.websockets.chat.create('7486520385140473856');

					ws.onopen = () => {
						ws.send({
							id: `ws-${new Date().getTime()}`,
							event_type: WebsocketsEventType.CHAT_UPDATE,
							data: {
								// 输入音频格式
								input_audio: {
									format: 'pcm',
									codec: 'pcm',
									sample_rate: 24000,
									channel: 1,
									bit_depth: 16,
								},
								output_audio: {
									voice_id: '7426720361733193737'
								},
								chat_config: {
									custom_variables: this.botInfo
								}
							},
						});

						ws.send({
							id: `ws-message-${new Date().getTime()}`,
							event_type: WebsocketsEventType.CONVERSATION_MESSAGE_CREATE,
							data: {
								role: RoleType.User,
								content: content,
								content_type: 'text',
							},
						});
					};

					ws.onmessage = (data, event) => {
						console.log(data, event);
						if (data.event_type === WebsocketsEventType.ERROR) {
							if (data.data.code === 4100) {
								console.error('Unauthorized Error', data);
							} else if (data.data.code === 4101) {
								console.error('Forbidden Error', data);
							} else {
								console.error('WebSocket error', data);
							}
							ws.close();
							return;
						}
						if (data.event_type === WebsocketsEventType.CONVERSATION_CHAT_CREATED) {
							this.handleDisconnect(); // 断开RTC
						}
						if (data.event_type === WebsocketsEventType.CONVERSATION_AUDIO_DELTA) {
							this.handleAudioMessage(data.data.content); // 语音播报
						} else if (data.event_type === WebsocketsEventType.CONVERSATION_MESSAGE_DELTA) {
							this.chatList[this.chatList.length - 1].content += data.data.content;
						} else if (data.event_type === WebsocketsEventType.CONVERSATION_CHAT_COMPLETED) {
							this.insurance(this.conversation_id, data.data.conversation_id);
							this.scrollToBottom();
						}
					};

					ws.onerror = error => {
						console.error('WebSocket error', error);
						ws.close();
					};
				}
			},
			// 对话提醒
			async remindChat() {
				if (this.popup && this.remind) {
					this.popup = false;
					return;
				}
				let index = this.chatList.length;
				if (index > 0) {
					let content = '';
					this.chatList.map((item, key) => {
						// 最后一句对话不能说业务员
						if (!(item.role == 'user' && key == index - 1)) {
							content += item.role == 'assistant' ? '顾客：' : '业务员：';
							content += item.content;
							content += "\n";
						}
					});
					content += `\n请分析顾客对话情景，以保险员第一人称直接给出一份100字内的标准回答`

					const stream = await this.api.chat.stream({
						bot_id: '7479998168428544035',
						additional_messages: [{
							role: RoleType.User,
							content: content,
							content_type: 'text',
						}],
					});

					this.popup = !this.popup;
					for await (const part of stream) {
						if (part.event === ChatEventType.CONVERSATION_MESSAGE_DELTA) {
							this.remind += part.data.content; // 实时响应
						}
					}
				}
			},
			// 对话分析
			async quickChat(index, type) {
				let content = '';
				this.chatList.map((item, key) => {
					if (key <= index) {
						content += item.role == 'assistant' ? '顾客：' : '业务员：';
						content += item.content;
						content += "\n";
					}
				});
				if (type == 'score') {
					this.chatList[index].show = 'score';
					if (this.chatList[index].score) {
						return;
					}
					this.chatList[index].loading = 'score';
					content += `\n请对燃气业务员最后一段话进行打分，请直接回答(0-100分)，不需要做出评价`
				} else if (type == 'suggestion') {
					this.chatList[index].show = 'suggestion';
					if (this.chatList[index].suggestion) {
						return;
					}
					this.chatList[index].loading = 'suggestion';
					content += `\n请对燃气业务员最后一段话提出100字改进建议`
				} else if (type == 'analysis') {
					this.chatList[index].show = 'analysis';
					if (this.chatList[index].analysis) {
						return;
					}
					this.chatList[index].loading = 'analysis';
					content += `\n请对燃气业务员最后一段话术详细分析下缺点和优点100字以内`
				} else if (type == 'intention') {
					this.chatList[index].show = 'intention';
					if (this.chatList[index].intention) {
						return;
					}
					this.chatList[index].loading = 'intention';
					content += `\n针对上面的对话，揣摩下顾客心理意图100字以内`
				} else if (type == 'emotion') {
					this.chatList[index].show = 'emotion';
					if (this.chatList[index].emotion) {
						return;
					}
					this.chatList[index].loading = 'emotion';
					content += `\n针对上面的对话，揣摩下顾客心理，进行100字以内的情绪分析`
				} else if (type == 'respond') {
					this.chatList[index].show = 'respond';
					if (this.chatList[index].respond) {
						return;
					}
					this.chatList[index].loading = 'respond';
					content += `\n针对上面的对话，揣摩下顾客心理，给业务员提供100字以内的应对技巧`
				}
				const v = await this.api.chat.createAndPoll({
					bot_id: '7479998168428544035',
					additional_messages: [{
						role: RoleType.User,
						content: content,
						content_type: 'text',
					}],
				});
				if (v.chat.status === ChatStatus.COMPLETED) {
					for (const item of v.messages) {
						if (item.type == 'answer') {
							this.chatList[index].loading = '';
							if (type == 'score') {
								this.chatList[index].score = item.content;
							} else if (type == 'suggestion') {
								this.chatList[index].show = 'suggestion';
								this.chatList[index].suggestion = item.content;
							} else if (type == 'analysis') {
								this.chatList[index].show = 'analysis';
								this.chatList[index].analysis = item.content;
							} else if (type == 'intention') {
								this.chatList[index].show = 'intention';
								this.chatList[index].intention = item.content;
							} else if (type == 'emotion') {
								this.chatList[index].show = 'emotion';
								this.chatList[index].emotion = item.content;
							} else if (type == 'respond') {
								this.chatList[index].show = 'respond';
								this.chatList[index].respond = item.content;
							}
						}
					}
				}
			},
			// 语音对话
			voiceChat() {
				try {
					if (this.end) {
						return;
					}
					// if (this.error) {
					// 	message.error('错误：' + this.error)
					// 	message.error('本次演练结束，请退出后重新发起演练。')
					// 	return;
					// }
					if (!this.audioEnabled && this.wait) {
						message.warning('请等待智能体响应...');
						return;
					}
					console.log('toggleMicrophone', !this.audioEnabled);
					this.client?.setAudioEnable(!this.audioEnabled);
					this.audioEnabled = !this.audioEnabled;
					if (this.audioEnabled) {
						// this.handleInterrupt();
						this.intervalID = setInterval(() => {
							this.time += 1;
						}, 1000);
						// VAD 检测开始
						this.client.sendMessage({
							id: `rtc-${new Date().getTime()}`,
							event_type: 'client.vad',
							data: {
								"vad": true
							}
						});
					} else {
						if (this.intervalID) {
							this.time = 0;
							clearInterval(this.intervalID);
						}
						// VAD 检测结束
						this.client.sendMessage({
							id: `rtc-${new Date().getTime()}`,
							event_type: 'client.vad',
							data: {
								"vad": false
							}
						});
					}
				} catch (error) {
					message.error('切换麦克风状态失败：' + error);
				}
			},
			async initClient() {
				if (this.client) {
					return;
				}

				this.client = new RealtimeClient({
					accessToken: getToken,
					botId: this.botId,
					connectorId: '1024',
					voiceId: this.botInfo.voice_id,
					allowPersonalAccessTokenInBrowser: true,
					audioMutedDefault: true, // 默认静音
					suppressStationaryNoise: true,
					debug: true,
				});

				this.handleMessageEvent();

				// 这段代码可选，主要处理移动端场景下，网络异常监控处理
				this.networkManager = new NetworkErrorManager(this.client);
				this.networkManager.onStatusChange = status => {
					this.connectStatus = status;
					this.isConnecting = status === 'connecting' || status === 'reconnecting';
					this.isConnected = status === 'connected';
				};
				// 这段代码可选，主要处理移动端场景下，网络异常监控处理
			},
			handleMessageEvent() {
				let lastEvent;
				this.client?.on(EventNames.ALL_SERVER, (eventName, event) => {
					console.log(eventName, event);
					if (event.event_type === 'error') {
						this.error = event.data.msg;
						// 发生错误
						if (event.data.code == 4029) {
							message.error('由于长时间没有收到对话，本次演练结束，请退出后重新发起演练。');
						} else {
							// message.error(event.data.msg);
						}
						return;
					}
					if (event.event_type === 'session.created') {
						// 由客户端检测 VAD
						this.client.sendMessage({
							id: `rtc-${new Date().getTime()}`,
							event_type: 'session.update',
							data: {
								turn_detection: {
									type: 'client_vad',
									silence_duration_ms: 2000
								}
							}
						});
					}
					if (event.event_type === 'audio.agent.speech_stopped') {
						//智能体结束说话
						if (this.end) {
							this.reportChat(this.chatList[this.chatList.length - 1].key);
						}
					}
					if (event.event_type == 'conversation.created') {
						this.conversation_id = event.data.conversation_id;
						this.insurance(event.data.conversation_id);
						this.chatList.push({
							role: 'assistant',
							content: event.data.prologue
						});
					}
					if (event.event_type !== ChatEventType.CONVERSATION_MESSAGE_DELTA && event.event_type !== ChatEventType.CONVERSATION_MESSAGE_COMPLETED) {
						return;
					}
					const content = event.data.content;
					if (event.data.role == 'user') {
						this.wait = true;
						this.scrollToBottom();
						this.chatList.push({
							role: 'user',
							content: content
						});
					}

					if (lastEvent?.event_type === ChatEventType.CONVERSATION_MESSAGE_DELTA) {
						this.wait = false;
						if (event.event_type != ChatEventType.CONVERSATION_MESSAGE_COMPLETED) {
							this.chatList[this.chatList.length - 1].content += content;
						}
					} else if (event.event_type === ChatEventType.CONVERSATION_MESSAGE_DELTA) {
						this.scrollToBottom();
						this.wait = false;
						this.chatList.push({
							role: event.data.role,
							content: content,
						});
					}
					
					// 检测对话是否可以结束并开始准备报告
					if (event.data.role == 'assistant' && event.data.type == 'answer' && event.event_type === ChatEventType.CONVERSATION_MESSAGE_COMPLETED) {
						this.keywords.some((item, key) => {
							let index = content.indexOf(item);
							if (index > -1) {
								this.end = true;
								this.chatList.push({
									role: 'report',
									content: '',
									key: key
								});
								return true;
							}
						});
					}
					
					lastEvent = event;
				});
			},
			async handleConnect() {
				try {
					if (!this.client) {
						await this.initClient();
					}

					await this.client?.connect();
					this.isConnected = true;
				} catch (error) {
					this.isConnecting = false;
					console.error(error);
					if (error instanceof RealtimeAPIError) {
						switch (error.code) {
							case RealtimeError.CREATE_ROOM_ERROR:
								message.error(`创建房间失败: ${error.message}`);
								break;
							case RealtimeError.CONNECTION_ERROR:
								message.error(`加入房间失败: ${error.message}`);
								break;
							case RealtimeError.DEVICE_ACCESS_ERROR:
								message.error(`获取设备失败: ${error.message}`);
								break;
							default:
								message.error(`连接错误: ${error.message}`);
						}
					} else {
						message.error('连接错误：' + error);
					}
				}
			},
			handleInterrupt() {
				try {
					this.client?.interrupt();
				} catch (error) {
					message.error('打断失败：' + error);
				}
			},
			handleDisconnect() {
				try {
					this.client?.disconnect();
				} catch (error) {
					message.error('断开失败：' + error);
				}
			},
			toggleMicrophone() {
				try {
					this.client?.setAudioEnable(!this.audioEnabled);
					this.audioEnabled = !this.audioEnabled;
				} catch (error) {
					message.error('切换麦克风状态失败：' + error);
				}
			},
			async handleAudioMessage(content) {
				if(this.audio && this.audio.isPlaying()) {
					this.audio.pause();
				}
				// Connect to audio output
				if (!this.isWspConnected) {
					this.isWspConnected = true;
					await wavStreamPlayer.connect();
				}
				const decodedContent = polyfill.atob(content);
				const arrayBuffer = new ArrayBuffer(decodedContent.length);
				const view = new Uint8Array(arrayBuffer);
				for (let i = 0; i < decodedContent.length; i++) {
					view[i] = decodedContent.charCodeAt(i);
				}
				wavStreamPlayer.add16BitPCM(arrayBuffer, `my-track-${new Date().getTime()}`);
			},
			formatSeconds(seconds) {
				var result = typeof seconds === "string" ? parseFloat(seconds) : seconds;
				if (isNaN(result) || result < 0) return "00:00";

				let h = Math.floor(result / 3600);
				let m = Math.floor((result / 60) % 60) + h * 60;
				let s = Math.floor(result % 60);

				m = m.toString().padStart(2, '0');
				s = s.toString().padStart(2, '0');
				return `${m}:${s}`;
			},
			scrollToBottom() {
				setTimeout(() => {
					const e = document.getElementById('chatList');
					e.scrollTop = e.scrollHeight;
				}, 1000);
			},
			insurance(conversation_id, sum_up_conversation_id){
				axios({
					url: 'https://api.wuweimed.com/ai_chat/index/gas_insurance_ai',
					method: 'POST',
					data: {
						conversation_id,
						sum_up_conversation_id
					}
				})
				.then(response => {
					console.log(response.data);
				})
				.catch(error => {
					console.error('There was an error!', error);
				});
			}
		},
		beforeUnmount() {
			this.networkManager?.destroy();
			this.handleDisconnect();
		},
	};
</script>
<style>
	#app {
		font-size: 14px;
		line-height: 1.3;
		min-height: 100vh;
		background: linear-gradient(180deg, #9EB0FF 0%, #3D61FF 100%) !important;
	}

	.uni-flex {
		display: flex;
		flex-direction: row;
	}

	.bg-but {
		background: url(https://h5.wuweimed.com/static/chat/010.png) no-repeat bottom center;
		background-size: 100%;
	}

	.scroll-container {
		overflow: hidden;
		white-space: nowrap;
		box-sizing: border-box;
	}

	.scroll-text {
		display: inline-block;
		animation: scrollText 12s linear infinite;
	}

	@keyframes scrollText {
		0% {
			transform: translateX(0);
		}

		100% {
			transform: translateX(-100%);
		}
	}
	.ant-spin-container::after {
		background: none !important;
	}
	.ant-spin-blur {
		opacity: 1 !important;
	}
</style>